
import React from "react";

export function SupplierFormatter(cellContent,row){

    return(
        <>
            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                {row.supplierName}
            </span>
            <span className="text-muted font-weight-bold">
                {row.supplierEmail}
            </span>
        </>
    )
}